import { ISearchPage, ICmSearchPageFields } from "../../../types/FmsTypes";
export enum OptType {
    ADD_ROOT = 1,//跟
    ADD_SAME_LEVEL = 2,//同级
    ADD_CHILD_LEVEL = 3,//孩子
    DETAIL = 4//编辑
}
//搜索参数
export interface IMaterielTypeParams {
    enable?: string,
    name?: string,
    branch?: string
}
//列表参数
export interface IMaterielTypeDetail {
    "branch"?: string,
    "ver"?: number,
    "enable"?: number,
    "code"?: string,
    "name"?: string,
    "pcode"?: string|null,
    "note"?:string,
    "children"?: IMaterielTypeDetail[] | null,
    "key"?: string
}
//新增参数
export interface IMaterielTypeInsert {
    "branch"?: string,
    "name"?: string,
    "pcode"?: string|null,
    "note"?: string
    [key: string]: any
}
//修改参数
export interface IMaterielTypeUpdate {
    "branch"?: string,
    "code"?: string,
    "name"?: string,
    [key: string]: any
}
//禁用参数
export interface IMaterielTypeDisable {
    "branch": string,
    "code": string
}
//删除参数
export interface IMaterielTypeRemove {
    "sourceApp"?: string,
    "branch"?: string,
    "code"?: string,
    [key: string]: any
}

export interface IIMaterielTypeSearch extends IMaterielTypeParams, ICmSearchPageFields {

}